var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.04,
    height: 38.4,
    viewBox: "0 0 23.04 38.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(10.24 3.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M243.733,42.667h-3.84a.96.96,0,1,0,0,1.92h3.84a.96.96,0,1,0,0-1.92Z",
    transform: "translate(-238.933 -42.667)",
    fill: "#263a4b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M121.6,0H106.24a3.845,3.845,0,0,0-3.84,3.84V34.56a3.845,3.845,0,0,0,3.84,3.84H121.6a3.845,3.845,0,0,0,3.84-3.84V3.84A3.845,3.845,0,0,0,121.6,0Zm1.92,34.56a1.92,1.92,0,0,1-1.92,1.92H106.24a1.92,1.92,0,0,1-1.92-1.92V3.84a1.92,1.92,0,0,1,1.92-1.92H121.6a1.92,1.92,0,0,1,1.92,1.92Z",
    transform: "translate(-102.4)",
    fill: "#263a4b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    transform: "translate(9.6 31.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 1.92,
    cy: 1.92,
    r: 1.92,
    fill: "#263a4b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    transform: "translate(7.04 3.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 0.96,
    cy: 0.96,
    r: 0.96,
    fill: "#263a4b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactphone);
export default __webpack_public_path__ + "static/media/contactphone.ce3f92915bfee83199be69ef2d939c7e.svg";
export { ForwardRef as ReactComponent };